import { useEffect, useRef } from 'react';

import { pageBlocks } from './editor';
import { shownPage, shownTabs } from './lensTabs';
import type { LensDocument, LensDocumentData } from './types';

function shownReach(document: LensDocument, tabs: Array<string>, data: LensDocumentData | undefined) {
  if (!data) return undefined;
  const switchedOn = (when: Record<string, Array<string>>) =>
    Object.entries(when).every(([name, values]) => values.includes(String(data.params[name.replace(/^\$/, '')])));
  const blocks = pageBlocks(shownPage(document.page, tabs)).filter(
    (block) => !block.when || switchedOn(block.when as Record<string, Array<string>>),
  );
  if (blocks.some((block) => !data.blocks[block.id])) return undefined;
  const envelopes = blocks
    .flatMap((block) => data.blocks[block.id].queries ?? (data.blocks[block.id].query ? [data.blocks[block.id].query!] : []))
    .map((id) => data.queries[id]);
  if (envelopes.some((envelope) => !envelope)) return undefined;
  return new Set(envelopes.flatMap((envelope) => envelope.reach));
}

export default function useShownReach(
  document: LensDocument,
  tabs: Array<string>,
  data: LensDocumentData | undefined,
): Set<string> | undefined {
  const settled = useRef(new Map<string, Set<string>>());
  const key = shownTabs(document.page, tabs).join('/');
  const reach = shownReach(document, tabs, data);
  useEffect(() => {
    if (reach) settled.current.set(key, reach);
  }, [key, reach]);
  return reach ?? settled.current.get(key);
}
